import * as React from 'react'

import { ListItem, ListItemIcon, Tooltip, Typography } from '@mui/material'
import { SvgIconProps } from '@mui/material/SvgIcon'

interface IExpandableListItemProps {
  expanded: boolean
  disabled?: boolean
  icon: React.ReactElement<SvgIconProps>
  text: string
  onClick?: (event: React.MouseEvent<HTMLElement>) => void
}

class ExpandableListItem extends React.Component<IExpandableListItemProps> {
  public render() {
    const { disabled, expanded, icon, onClick, text } = this.props
    const displayText = expanded ? text : null
    const toolTipText = expanded ? null : text

    return (
      <ListItem
        onClick={onClick}
        disabled={disabled}
        sx={{
          paddingLeft: 2,
          paddingRight: 2,
          paddingTop: expanded ? 1 : 0.5,
          paddingBottom: expanded ? 1 : 0.5,
          cursor: 'pointer',
          minHeight: expanded ? 'auto' : 40,
          '&:hover': {
            backgroundColor: 'action.hover',
          },
        }}
      >
        <Tooltip
          title={toolTipText || ''}
          placement="right-start"
          disableFocusListener={expanded}
          disableHoverListener={expanded}
          disableTouchListener={expanded}
        >
          <ListItemIcon
            sx={{
              minWidth: expanded ? 40 : 'auto',
              marginRight: expanded ? 1 : 0,
              justifyContent: expanded ? 'flex-start' : 'center',
              flexShrink: 0,
            }}
          >
            {icon}
          </ListItemIcon>
        </Tooltip>
        {expanded && (
          <Typography
            noWrap
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              flex: 1,
            }}
          >
            {displayText}
          </Typography>
        )}
      </ListItem>
    )
  }
}

export default ExpandableListItem
export { IExpandableListItemProps }
